import React, { useEffect, useState } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Box,
  Button,
  IconButton,
  Divider,
  CircularProgress,
} from "@mui/material";
import { useParams ,useNavigate} from "react-router-dom";
import axios from "axios";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import ShareIcon from "@mui/icons-material/Share";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import CallIcon from "@mui/icons-material/Call";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import NoPhotographyIcon from "@mui/icons-material/NoPhotography";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { BASE_URL } from "../../Api/ApiUrls";
// Import your bottom navbar
import BottomNavbar from "./../Rent Module/BottomNavbar/BottomNavbar";
import DownloadIcon from "@mui/icons-material/Download";
import CopyFailureAlert from '../Alertpage/CopyAlert/CopyFailureAlert';
import CopySuccessAlert from '../Alertpage/CopyAlert/CopySuccessAlert';

const BANK_API = `${BASE_URL}/auction-property/`;
  
const AuctionPropertyCardDynamic = () => {
  const { id } = useParams();
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [locationLoading, setLocationLoading] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);
  const [allImages, setAllImages] = useState([]);
    const navigate = useNavigate();
        const [showSuccess, setShowSuccess] = useState(false);
      const [showFailure, setShowFailure] = useState(false);
      const [alertMessage, setAlertMessage] = useState('');
    

useEffect(() => {
  const fetchProperty = async () => {
    try {
      const res = await axios.get(BANK_API);
      
      // Get the data array from response
      const dataArray = res.data?.data || res.data?.results || res.data;
      
      // Only proceed if it's an array
      if (Array.isArray(dataArray)) {
        const found = dataArray.find((item) => String(item.bankprop_id) === id);
        
        if (found) {
          setProperty(found);
          
          if (found.bank_pro_doc && found.bank_pro_doc.length > 0) {
            const images = found.bank_pro_doc.map(doc => ({
              id: doc.doc_id,
              url: doc.document,
              uploaded_at: doc.uploaded_at
            }));
            setAllImages(images);
          } else {
            setAllImages([]);
          }
        }
      }
      
      setLoading(false);
    } catch (err) {
      console.error("Error fetching property:", err);
      setLoading(false);
    }
  };
  fetchProperty();
}, [id]);

  const formatPropertyId = (id) => {
    return `BAP${String(id).padStart(4, '0')}`;
  };

  const handleLocationClick = () => {
    if (!property || !property.lat || !property.long) {
      window.alert("Location coordinates not available");
      return;
    }
    
    setLocationLoading(true);
    
    const openInMaps = (url) => {
      setLocationLoading(false);
      window.open(url, '_blank', 'noopener,noreferrer');
    };

    const locationString =  `${property.lat},${property.long}`;
    const fallbackUrl = `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(locationString)}`;
    
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const userLat = position.coords.latitude;
          const userLng = position.coords.longitude;
          
          const mapsUrl = property.lat && property.long
            ? `https://www.google.com/maps/dir/?api=1&origin=${userLat},${userLng}&destination=${property.lat},${property.long}&travelmode=driving`
            : fallbackUrl;
          openInMaps(mapsUrl);
        },
        (error) => {
          console.error("Error getting location:", error);
          openInMaps(fallbackUrl);
        },
        { timeout: 10000 }
      );
    } else {
      openInMaps(fallbackUrl);
    }
  };
const handleCallButtonClick = () => {
  if (property?.bank_contact_details) {
    navigator.clipboard.writeText(property.bank_contact_details)
      .then(() => {
        setAlertMessage(
          `Contact number copied: ${property.bank_contact_details}\n\nProperty ID: ${formatPropertyId(property.bankprop_id)}`
        );
        setShowSuccess(true);
      })
      .catch((err) => {
        console.error("Failed to copy:", err);

        setAlertMessage("Failed to copy contact number");
        setShowFailure(true);
      });
  } else {
    setAlertMessage("Contact number not available");
    setShowFailure(true);
  }
};

  // Format the image URL
  const getImageUrl = (imagePath) => {
    if (!imagePath) return null;
    
    if (imagePath.startsWith('http')) {
      return imagePath;
    }
    
    return `${BASE_URL}${imagePath}`;
  };

  // Carousel navigation
  const nextImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === allImages.length - 1 ? 0 : prevIndex + 1
    );
  };

  const prevImage = () => {
    setCurrentImageIndex((prevIndex) => 
      prevIndex === 0 ? allImages.length - 1 : prevIndex - 1
    );
  };

  // Handle image click to navigate
  const handleImageClick = (index) => {
    setCurrentImageIndex(index);
  };

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <CircularProgress />
      </Box>
    );
  }
  
  if (!property) {
    return (
      <Box sx={{ p: 2, textAlign: 'center' }}>
        <Typography>Property not found</Typography>
      </Box>
    );
  }

  const currentImage = allImages.length > 0 ? allImages[currentImageIndex] : null;

  const handleDownloadImage = async () => {
  if (!currentImage) return;

  try {
    const imageUrl = getImageUrl(currentImage.url);

    const response = await fetch(imageUrl);
    const blob = await response.blob();

    const link = document.createElement("a");
    link.href = window.URL.createObjectURL(blob);
    link.download = `/Auction_Property_${formatPropertyId(property.bankprop_id)}_${currentImageIndex + 1}.png`;

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  } catch (error) {
    console.error("Download failed:", error);
    window.alert("Failed to download image");
  }
};


  return (
    <Box sx={{ 
      height: '100vh', 
      display: 'flex', 
      flexDirection: 'column',
      pb: 7
    }}>
      {/* Fixed Header */}
      <Box
        sx={{
          backgroundColor: "black",
          color: "#fff",
          px: 2,
          py: 1.5,
          display: "flex",
          alignItems: "center",
          gap: 1,
          position: 'sticky',
          top: 0,
          zIndex: 1000,
          flexShrink: 0,
        }}
      >
        <IconButton
          size="small"
          sx={{ color: "#fff" }}
          onClick={() => window.history.back()}
        >
          <ArrowBackIosNewIcon fontSize="small" />
        </IconButton>

        <Typography fontWeight={600} flexGrow={1}>
          Auction Property
        </Typography>

        <Box textAlign="right">
          <Typography variant="caption">
            ID: {formatPropertyId(property.bankprop_id)}
          </Typography>
         <Typography variant="caption" display="block">
  Date:{" "}
  {new Date(property.created_at).toLocaleDateString("en-GB")}
</Typography>
        </Box>
      </Box>

      {/* Scrollable Content */}
      <Box sx={{ 
        flex: 1,
        overflowY: 'auto',
        overflowX: 'hidden',
        mx: "auto",
        width: '100%',
        maxWidth: 420,
      }}>
        <Card sx={{ boxShadow: 4, borderRadius: 0, border: 'none' }}>
          <Box sx={{ p: 2 }}>
            {/* Image Carousel */}
            <Box position="relative" sx={{ height: 190, borderRadius: 2, overflow: 'hidden' }}>
              {allImages.length > 0 ? (
                <>
                  <CardMedia
                    component="img"
                    height="190"
                    image={getImageUrl(currentImage.url)}
                    alt={`Property ${currentImageIndex + 1}`}
                    sx={{ 
                      borderRadius: 2,
                      width: '100%',
                      height: '100%',
                      objectFit: 'cover'
                    }}
                    onError={(e) => {
                      e.target.src = 'https://via.placeholder.com/400x200?text=Image+Not+Available';
                    }}
                  />
                  

                  {/* Download Button */}
<IconButton
  onClick={handleDownloadImage}
  sx={{
    position: "absolute",
    top: 8,
    right: 8,
    backgroundColor: "rgba(0,0,0,0.6)",
    color: "#fff",
    "&:hover": {
      backgroundColor: "rgba(0,0,0,0.8)",
    },
  }}
>
  <DownloadIcon />
</IconButton>

                  {/* Left Navigation Button */}
                  {allImages.length > 1 && (
                    <IconButton
                      onClick={prevImage}
                      sx={{
                        position: 'absolute',
                        left: 8,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        '&:hover': {
                          backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        },
                      }}
                    >
                      <ChevronLeftIcon />
                    </IconButton>
                  )}
                  
                  {/* Right Navigation Button */}
                  {allImages.length > 1 && (
                    <IconButton
                      onClick={nextImage}
                      sx={{
                        position: 'absolute',
                        right: 8,
                        top: '50%',
                        transform: 'translateY(-50%)',
                        backgroundColor: 'rgba(255, 255, 255, 0.8)',
                        '&:hover': {
                          backgroundColor: 'rgba(255, 255, 255, 0.9)',
                        },
                      }}
                    >
                      <ChevronRightIcon />
                    </IconButton>
                  )}
                  
                  {/* Image counter */}
                  <Box
                    position="absolute"
                    bottom={8}
                    right={8}
                    sx={{
                      backgroundColor: 'rgba(0, 0, 0, 0.7)',
                      color: 'white',
                      padding: '2px 8px',
                      borderRadius: '12px',
                      fontSize: '0.75rem'
                    }}
                  >
                    {currentImageIndex + 1} / {allImages.length}
                  </Box>
                </>
              ) : (
                <Box
                  sx={{
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#f5f5f5',
                    borderRadius: 2
                  }}
                >
                  <NoPhotographyIcon sx={{ fontSize: 48, color: '#ccc', mb: 1 }} />
                  <Typography variant="body2" color="text.secondary">
                    No image available
                  </Typography>
                </Box>
              )}
            </Box>

            {/* Dots Indicator - Only show if more than 1 image */}
            {allImages.length > 1 && (
              <Box sx={{ display: 'flex', justifyContent: 'center', mt: 1, gap: 0.5 }}>
                {allImages.map((_, index) => (
                  <Box
                    key={index}
                    onClick={() => handleImageClick(index)}
                    sx={{
                      width: 8,
                      height: 8,
                      borderRadius: '50%',
                      backgroundColor: index === currentImageIndex ? '#1976d2' : '#ccc',
                      cursor: 'pointer',
                      '&:hover': {
                        backgroundColor: index === currentImageIndex ? '#1976d2' : '#aaa',
                      }
                    }}
                  />
                ))}
              </Box>
            )}

            <CardContent sx={{ p: 0, pt: 2 }}>
              {/* Reserve Price */}
              <Box
                sx={{
                  backgroundColor: "#fff1f0",
                  p: 2,
                  borderRadius: 2,
                  mb: 2,
                }}
              >
                <Typography variant="body2" color="text.secondary">
                  Reserve Price
                </Typography>
                <Typography variant="h6" color="error" fontWeight={700}>
                  ₹{property.reserve_price}
                </Typography>
              </Box>

              {/* Property Info */}
              <Typography variant="body2">
                <b>Property type:</b> {property.property_type || "Not specified"}
              </Typography>

              <Typography variant="body2" mt={1}>
                <b>City/Town:</b> {property.city_town || "Not specified"} / {property.area_town || "Not specified"}
              </Typography>

  <Box mt={1}>
  <Box
    onClick={handleLocationClick}
    sx={{
      cursor: "pointer",
      borderRadius: 1,
      p: 0.5,
      "&:hover": {
        backgroundColor: "#f0f0f0",
      },
    }}
  >
    {/* First Row */}
    <Box sx={{ display: "flex", alignItems: "center" }}>
      <Typography variant="body2">
        <b>Location:</b>
      </Typography>

      {locationLoading ? (
        <CircularProgress size={16} sx={{ ml: 0.5 }} />
      ) : (
        <LocationOnIcon
          sx={{ color: "#1976d2", fontSize: "1rem", ml: 0.5 }}
        />
      )}
      
      <Typography variant="body2" sx={{ ml: 1, color: "#555" }}>
        {property.location?.split(",")[0]}
      </Typography>
    </Box>

    {/* Second Row (remaining address) */}
    <Typography
     variant="body2"
  sx={{
    color: "#555",
    lineHeight: 1.6,          // ✅ more vertical spacing
    textAlign: "justify",     // ✅ left + right align
    textJustify: "inter-word",// ✅ better spacing between words
                     // ✅ more gap from above
    
  }}
>
      {property.location
        ?.split(",")
        .slice(1)
        .join(",")}
    </Typography>
  </Box>
</Box>
              <Typography variant="body2" mt={1}>
                <b>Area:</b> {property.area || "Not specified"} {property.units || ""}
              </Typography>

              {/* Details Box */}
              <Box
                sx={{
                  backgroundColor: "#f9f9f9",
                  p: 2,
                  borderRadius: 2,
                  mt: 2,
                }}
              >
                <InfoRow 
                  label="EMD Amount" 
                  value={property.emd_amount ? `₹${property.emd_amount}` : "Not specified"} 
                />
                <InfoRow 
                  label="Bid Increment" 
                  value={property.bid_increment ? `₹${property.bid_increment}` : "Not specified"} 
                />
                <InfoRow 
                  label="EMD Submission" 
                  value={property.emd_submission ? new Date(property.emd_submission).toLocaleString() : "Not specified"} 
                />
                <InfoRow 
                  label="Auction Start" 
                  value={property.auction_start_datetime ? new Date(property.auction_start_datetime).toLocaleString() : "Not specified"} 
                />
                <InfoRow 
                  label="Auction End" 
                  value={property.auction_end_datetime ? new Date(property.auction_end_datetime).toLocaleString() : "Not specified"} 
                />
                <InfoRow 
                  label="Possession" 
                  value={`${property.possession_status || "Not specified"} / ${property.possession || "Not specified"}`} 
                />
              </Box>

              {/* <Button fullWidth variant="contained" sx={{ mt: 2 }}>
                Download Auction File
              </Button> */}

              <Divider sx={{ my: 2 }} />

              {/* Bank Info */}
              <Box display="flex" justifyContent="space-between" alignItems="center" mb={7}>
                <Box>
                  <Typography fontWeight={600}>{property.bank_name || "Bank name not specified"}</Typography>
                  <Typography variant="body2" color="text.secondary">
                    Contact: {property.bank_contact_details || "Not available"}
                  </Typography>
                </Box>
                <Button
                  variant="outlined"
                  size="small"
                  startIcon={<CallIcon />}
                  sx={{ textTransform: "none" }}
                  onClick={handleCallButtonClick}
                >
                  Call
                </Button>
              </Box>
                 
      
            </CardContent>
          </Box>
        </Card>
      </Box>
     
               {/* Add these alert components */}
      {showSuccess && (
        <CopySuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowSuccess(false);
            setAlertMessage("");
          }}
        />
      )}
      
      {showFailure && (
        <CopyFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowFailure(false);
            setAlertMessage("");
          }}
        />
      )}


      {/* Fixed Bottom Navbar */}
      <Box sx={{ 
        position: "fixed", 
        bottom: 0, 
        left: 0, 
        right: 0,
        zIndex: 1000
      }}>
        <BottomNavbar />
      </Box>
    </Box>
  );
};

/* Reusable Row */
const InfoRow = ({ label, value }) => (
  <Box display="flex" justifyContent="space-between" mb={1}>
    <Typography variant="body2" color="text.secondary">
      {label}
    </Typography>
    <Typography variant="body2" fontWeight={600}>
      {value}
    </Typography>
  </Box>
);

export default AuctionPropertyCardDynamic;